import { render, staticRenderFns } from "./dic.vue?vue&type=template&id=1027815e&"
import script from "./dic.vue?vue&type=script&lang=js&"
export * from "./dic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports